import { FC, ReactNode, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useSnackbar } from 'notistack';
import { useStore } from 'hooks/useRootStore';
import { useStyles } from './styles';

export const Notification: FC<{ children: ReactNode }> = observer(({ children }) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const {
    notificationStore: { type, isOpen, message, direction, closeNotification },
  } = useStore();

  useEffect(() => {
    if (isOpen) {
      enqueueSnackbar(message, {
        variant: type as 'default' | 'error' | 'success' | 'warning' | 'info',
        anchorOrigin: {
          vertical: direction === 'top' ? 'top' : 'bottom',
          horizontal: 'center',
        },
        className: classes.NotificationStyling,
        autoHideDuration: 5000,
        hideIconVariant: true,
        onClose: closeNotification,
      });
    }
  }, [isOpen, message, type, direction, enqueueSnackbar, closeNotification, classes.NotificationStyling]);

  return <>{children}</>;
});
